import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchProducts} from "../store/actions/productAction";
import { fetchCategories } from "../store/actions/categoryAction";
import { useNavigate } from "react-router-dom";

export default function CategoryPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [categoryId, setCategoryId] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);

  const { products } = useSelector((state) => {
    return state.products;
  });
  const { categories } = useSelector((state) => {
    return state.categories;
  });

  const handleDetail = (id) => {
    navigate(`/products/detail/${id}`)
  }

  useEffect(() => {
    dispatch(fetchProducts({categoryId, name}));
    dispatch(fetchCategories());
    setLoading(false)
  }, [name, categoryId]);

  if (loading) {
    return <div><h1 className="flex flex-row justify-center items-center">loading ...</h1></div>
  }

  return (
    <div>
      <hr></hr>
      <img
        className="mx-auto px-6 pt-4 pb-5 h-60 w-1/2"
        src="https://i.imgur.com/DZtW4YV.jpg"
      ></img>
      <div className="mx-40 px-10 h-14 w-10/12 bg-orange-300 flex-row inline-flex items-center justify-center">
      
      <img src="https://img.icons8.com/stickers/344/spa-flower.png" className="w-6 mr-2" />
      <h1 className="text-white font-bold text-xl text-center mr-2 "> Quick Flower Finder</h1>
      <select value={categoryId}
          onChange={(e) => setCategoryId(e.target.value)}
          className="h-10 rounded-sm border-0 bg-orange-100 text-slate-600">
        <option value="" selected>
          All Category
        </option>
        {categories.map((category) => (
          <option
            key={category.id}
            value={category.id}
          >
            {category.name}
          </option>
        ))}
      </select>
      
      <div className="md:flex space-x-6 ml-10 hidden">
                <input
                  className="outline-none text-sm flex-grow bg-gray-100 "
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Search flowers..."
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 mt-3 cursor-pointer text-gray-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
      </div>
      <div>
        <div className="mx-36 px-10 py-20 bg-white-100 grid gap-10 lg:grid-cols-3 xl:grid-cols-4 sm:grid-cols-2">
          
        {products.map((e) => (
          <div className="max-w-xs rounded-md overflow-hidden shadow-lg hover:scale-105 transition duration-500 cursor-pointer">
            <div>
              <img
                src={e.mainImg}
                alt=""
              />
            </div>
            <div className="py-4 px-4 bg-white">
              <h3 className="text-md font-semibold text-gray-600">
               {e.name}
              </h3>
              <p className="mt-4 text-lg font-thin">{(e.price).toLocaleString("id-ID", {style:"currency", currency:"IDR"})}</p>
                <button onClick={() => handleDetail(e.id)} className="font-semibold text-white  ">
              <span className="flex items-center justify-center mt-4 w-56 bg-rose-400 hover:bg-rose-600 py-1 rounded">
                  Detail
              </span>
                </button>
            </div>
          </div>
        ))}
        </div>
      </div>
    </div>
  );
}
